import React from 'react';
import { config } from 'config';
import { useInput } from 'hooks';
import { useTranslation } from 'react-i18next';
import {
    BackendConfiguration,
    CampaignsConfiguration,
    ChatbotConfiguration,
    ChatbotFeatureConfiguration,
    CronConfiguration,
    ServicesConfiguration
} from './components';
import {
    Container,
    TabController
} from 'mol-ui';
const { campaigns, chatbot } = config;

const BACKEND = 'backend';
const CAMPAIGNS = 'campaigns';
const CHATBOT = 'chatbot';
const CHATBOT_FEATURE = 'chatbot_feature';
const CRON = 'cron';
const SERVICES = 'services';

const PlatformConfiguration = () => {

    const { t } = useTranslation();
    const [tabInput, selectedTab] = useInput(BACKEND);

    const tabOptions = [{
        key: BACKEND,
        label: t('Backend')
    }, {
        display: campaigns,
        key: CAMPAIGNS,
        label: t('Campañas')
    }, {
        display: chatbot,
        key: CHATBOT,
        label: t('Chatbot')
    }, {
        display: chatbot,
        key: CHATBOT_FEATURE,
        label: t('Chatbot feature')
    }, {
        key: CRON,
        label: t('CRON')
    }, {
        key: SERVICES,
        label: t('Servicios')
    }];

    return (
        <Container height="100%">
            <TabController
                { ...tabInput }
                items={ tabOptions }
                padding="0px 10px"
            />
            <Container height="calc(100% - 50px)" overflowY="auto">
                { selectedTab === BACKEND && <BackendConfiguration /> }
                { campaigns && selectedTab === CAMPAIGNS && <CampaignsConfiguration /> }
                { chatbot && selectedTab === CHATBOT && <ChatbotConfiguration /> }
                { chatbot && selectedTab === CHATBOT_FEATURE && <ChatbotFeatureConfiguration /> }
                { selectedTab === CRON && <CronConfiguration /> }
                { selectedTab === SERVICES && <ServicesConfiguration /> }
            </Container>
        </Container>
    );
};

export default PlatformConfiguration;
